/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoCommonSafetyCodeLogListListData model module.
 * @module model/LogControllerDtoCommonSafetyCodeLogListListData
 * @version 1.0
 */
class LogControllerDtoCommonSafetyCodeLogListListData {
    /**
     * Constructs a new <code>LogControllerDtoCommonSafetyCodeLogListListData</code>.
     * @alias module:model/LogControllerDtoCommonSafetyCodeLogListListData
     */
    constructor() { 
        
        LogControllerDtoCommonSafetyCodeLogListListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoCommonSafetyCodeLogListListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoCommonSafetyCodeLogListListData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoCommonSafetyCodeLogListListData} The populated <code>LogControllerDtoCommonSafetyCodeLogListListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoCommonSafetyCodeLogListListData();

            if (data.hasOwnProperty('safetyNo')) {
                obj['safetyNo'] = ApiClient.convertToType(data['safetyNo'], 'Number');
            }
            if (data.hasOwnProperty('contentsIndex')) {
                obj['contentsIndex'] = ApiClient.convertToType(data['contentsIndex'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('targetId')) {
                obj['targetId'] = ApiClient.convertToType(data['targetId'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('safetyCode')) {
                obj['safetyCode'] = ApiClient.convertToType(data['safetyCode'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoCommonSafetyCodeLogListListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoCommonSafetyCodeLogListListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['targetId'] && !(typeof data['targetId'] === 'string' || data['targetId'] instanceof String)) {
            throw new Error("Expected the field `targetId` to be a primitive type in the JSON string but got " + data['targetId']);
        }
        // ensure the json data is a string
        if (data['safetyCode'] && !(typeof data['safetyCode'] === 'string' || data['safetyCode'] instanceof String)) {
            throw new Error("Expected the field `safetyCode` to be a primitive type in the JSON string but got " + data['safetyCode']);
        }

        return true;
    }


}



/**
 * @member {Number} safetyNo
 */
LogControllerDtoCommonSafetyCodeLogListListData.prototype['safetyNo'] = undefined;

/**
 * @member {Number} contentsIndex
 */
LogControllerDtoCommonSafetyCodeLogListListData.prototype['contentsIndex'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoCommonSafetyCodeLogListListData.prototype['accountNo'] = undefined;

/**
 * @member {String} targetId
 */
LogControllerDtoCommonSafetyCodeLogListListData.prototype['targetId'] = undefined;

/**
 * @member {Number} status
 */
LogControllerDtoCommonSafetyCodeLogListListData.prototype['status'] = undefined;

/**
 * @member {String} safetyCode
 */
LogControllerDtoCommonSafetyCodeLogListListData.prototype['safetyCode'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoCommonSafetyCodeLogListListData.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
LogControllerDtoCommonSafetyCodeLogListListData.prototype['updatedAt'] = undefined;






export default LogControllerDtoCommonSafetyCodeLogListListData;

